import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";

import axios from "axios";
import API_ENDPOINTS from "config/api";

function LogsTable() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_ENDPOINTS.AUDITORIA.LOGS);
      setLogs(response.data);
    } catch (error) {
      console.error("Error fetching logs:", error);
      // Fallback a datos de ejemplo si falla la API
      setLogs([
        {
          id: 1,
          usuario: "admin@sadems.com",
          accion: "LOGIN",
          modulo: "AUTH",
          descripcion: "Inicio de sesión exitoso",
          ip_address: "192.168.1.1",
          fecha: new Date().toISOString(),
        },
        {
          id: 2,
          usuario: "vendedor@sadems.com",
          accion: "CREATE",
          modulo: "VENTAS",
          descripcion: "Creación de factura FAC-001",
          ip_address: "192.168.1.5",
          fecha: new Date().toISOString(),
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { Header: "usuario", accessor: "usuario", align: "left" },
    { Header: "acción", accessor: "accion", align: "center" },
    { Header: "módulo", accessor: "modulo", align: "center" },
    { Header: "descripción", accessor: "descripcion", align: "left" },
    { Header: "ip", accessor: "ip_address", align: "center" },
    { Header: "fecha", accessor: "fecha", align: "center" },
  ];

  const rows = logs
    .filter(
      (log) =>
        log.usuario.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.modulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.accion.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .map((log) => ({
      usuario: (
        <MDTypography variant="caption" fontWeight="medium">
          {log.usuario}
        </MDTypography>
      ),
      accion: (
        <Chip
          label={log.accion}
          size="small"
          color={log.accion === "DELETE" ? "error" : log.accion === "CREATE" ? "success" : "info"}
        />
      ),
      modulo: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {log.modulo}
        </MDTypography>
      ),
      descripcion: (
        <MDTypography variant="caption" color="text">
          {log.descripcion}
        </MDTypography>
      ),
      ip_address: (
        <MDTypography variant="caption" color="text">
          {log.ip_address}
        </MDTypography>
      ),
      fecha: (
        <MDTypography variant="caption" color="text">
          {new Date(log.fecha).toLocaleString()}
        </MDTypography>
      ),
    }));

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Logs de Auditoría
          </MDTypography>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <Icon
              sx={{
                fontWeight: "bold",
                color: ({ palette: { info } }) => info.main,
                mt: -0.5,
              }}
            >
              done
            </Icon>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;<strong>Actividad reciente</strong> del sistema
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" gap={2}>
          <MDInput
            label="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            size="small"
          />
          <MDButton variant="gradient" color="info" onClick={fetchLogs} size="small">
            <Icon>refresh</Icon>
          </MDButton>
        </MDBox>
      </MDBox>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={true}
          isSorted={true}
          noEndBorder
          entriesPerPage={true}
        />
      </MDBox>
    </Card>
  );
}

export default LogsTable;
